// @ts-nocheck
import $ from 'jquery';

window.ClientSideValidations.formBuilders['SimpleForm::FormBuilder'] = {
  add: (element, settings, message) => {
    const rowBody = element.closest('.js-form-body');
    const row = rowBody.closest('.form__row--required');

    let labelErrorField = rowBody.find('.invalid-feedback');

    if (labelErrorField[0] === undefined) {
      labelErrorField = $('<span class="invalid-feedback" />');
      rowBody.append(labelErrorField);
    }

    row.toggleClass('is-invalid', true);
    element.toggleClass('is-invalid', true);
    labelErrorField.text(message);
    labelErrorField.show();
  },
  remove: (element) => {
    const rowBody = element.closest('.js-form-body');
    const row = rowBody.closest('.form__row--required');
    let labelErrorField = rowBody.find('.invalid-feedback');

    if (labelErrorField[0] === undefined) {
      labelErrorField = $('<span class="invalid-feedback" />');
      rowBody.append(labelErrorField);
    }

    element.toggleClass('is-invalid', false);
    if (row.find('.is-invalid').length === 0) {
      row.toggleClass('is-invalid', false);
      labelErrorField.text('');
    }
  },
};
